<!-- src/components/dashboard/KpiMiniCard.vue -->
<template>
  <div class="card kpi-mini-card">
    <div class="card-content kpi-mini-content" :style="cssVars">
      <div class="kpi-label">
        {{ label }}
      </div>

      <div class="kpi-value">
        {{ displayValue }}
      </div>

      <div v-if="subLabel" class="kpi-sub">
        {{ subLabel }}
      </div>

      <div v-if="delta !== null && delta !== undefined" class="kpi-delta">
        {{ delta }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

import {
  venueAuditBackground,
  adminAuditBackground,
} from "@/scripts/sharedHelpers/auditColours.js";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },

  value: {
    type: [Number, String],
    default: 0,
  },

  subLabel: {
    type: String,
    default: "",
  },

  delta: {
    type: [Number, String, null],
    default: null,
  },

  formatter: {
    type: Function,
    default: null,
  },

  tone: {
    type: String,
    default: "",
  },

  hasScore: {
    type: Boolean,
    default: false,
  },
});

const numericValue = computed(() => {
  const n = Number(props.value);

  return Number.isFinite(n) ? n : 0;
});

const displayValue = computed(() => {
  return typeof props.formatter === "function"
    ? props.formatter(numericValue.value)
    : String(props.value ?? "");
});

const bg = computed(() => {
  if (props.tone === "venue-audit") {
    return venueAuditBackground(numericValue.value, props.hasScore);
  }

  if (props.tone === "admin-audit") {
    return adminAuditBackground(numericValue.value, props.hasScore);
  }

  return "";
});

const cssVars = computed(() => {
  return bg.value ? { "--kpi-bg": bg.value } : {};
});
</script>

<style scoped>
.kpi-mini-card {
  border-radius: 10px;
  overflow: hidden;
}

.kpi-mini-content {
  background-color: var(--kpi-bg) !important;
}

.kpi-label {
  font-size: 12px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.55);
}

.kpi-value {
  margin-top: 8px;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.1;
  color: rgba(0, 0, 0, 0.87);
  overflow-wrap: anywhere;
}

.kpi-sub {
  margin-top: 8px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
}

.kpi-delta {
  margin-top: 6px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
}

@media (max-width: 600px) {
  .kpi-label {
    font-size: 11px;
  }

  .kpi-value {
    font-size: 28px;
  }

  .kpi-sub {
    font-size: 12px;
  }
}
</style>
